import { useMutation } from "urql";

import { UpdatePengurusDocument } from "../../../../graphql/generated.ts";

export function useUpdatePengurus() {
  return useMutation(UpdatePengurusDocument);
}
